import { useRef, useState } from "react";

import {
    DeletarMotivoCancelamentoController,
    ListarMotivoCancelamentoController,
} from "../../../../../Controllers/Geral/GestaoDeCadastros/MotivoCancelamento/MotivoCancelamentoController";
import {
    MotivoCancelamentoInterface,
    MotivoCancelamentoInterfaceResponse,
} from "../../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCancelamento/MotivoCancelamentoInterfaces";
import "./styles.css";

import Table from "../../../../Table";
import { ColumnDescription } from "react-bootstrap-table-next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { Collapse } from "react-bootstrap";
import CreateUpdateMotivoCancelamento from "./CreateUpdateMotivoCancelamento/CreateUpdateMotivoCancelamento";
import { IPropsTableChange } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

export default function MotivoCancelamento() {
    const [editting, setEditting] = useState<MotivoCancelamentoInterface>();
    const [pesquisaText, setPesquisaText] = useState("");

    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                ultimaPesquisaRef.current = newState.searchText;
            }
        }, 1500);
    }

    const {
        value: lstMotivoCancelamento,
        loading: lstMotivoCancelamentoLoading,
        execute: updateList,
    } = useAsyncEffect(
        () => ListarMotivoCancelamentoController(0, ultimaPesquisaRef.current),
        [ultimaPesquisaRef.current]
    );

    function Edit(toEdit: MotivoCancelamentoInterface) {
        if (editting?.ID_MOTIVO_CANCELAMENTO === toEdit.ID_MOTIVO_CANCELAMENTO)
            setEditting(undefined);
        else if (!editting) {
            setEditting(toEdit);
        } else {
            setEditting(undefined);
            setTimeout(() => {
                setEditting(toEdit);
            }, 500);
        }
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_MOTIVO_CANCELAMENTO",
            text: "Motivos de Cancelamento",
            formatter: rowMotivoCancelamento,
        },
        {
            dataField: "button",
            text: "Editar",
            formatExtraData: Edit,
            formatter: (c, row, _, setEdit) => (
                <div className="d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                            setEdit(row);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                </div>
            ),
        },
        {
            dataField: "button",
            text: "Deletar",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-danger font-weight-bold"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este motivo cancelamento?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarMotivoCancelamentoController(
                                        row.ID_MOTIVO_CANCELAMENTO
                                    ).then(() => {
                                        updateList();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                    </button>
                </div>
            ),
        },
    ];

    function rowMotivoCancelamento(
        cell: string,
        row: MotivoCancelamentoInterfaceResponse
    ) {
        return (
            <div className="rowCapysMC d-flex justify-content-between align-itens-center">
                <div
                    id={"dsMotivoCancelamento" + row.ID_MOTIVO_CANCELAMENTO}
                    className="d-flex flex-column dsMotivoCancelamento showLabel"
                >
                    <div>
                        <label>{row.DS_MOTIVO_CANCELAMENTO}</label>
                    </div>
                    <div>
                        <span className={`badge badge-primary text-white`}>
                            {row.DS_TIPO_CASO}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="Row1 d-flex flex-columns row">
            <div className="col-12 collapse mb-5" id="collapseForm">
                <CreateUpdateMotivoCancelamento
                    onSave={() => {
                        updateList();
                        setEditting(undefined);
                    }}
                />
            </div>
            <div className="col-12 mt-2">
                <Table
                    keyField="ID_MOTIVO_CANCELAMENTO"
                    columns={columns}
                    data={lstMotivoCancelamento || []}
                    sizePerPage={5}
                    loading={lstMotivoCancelamentoLoading}
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;

                        if (state.searchText !== pesquisaText) {
                            handleSearch(state.searchText, state);
                            setPesquisaText(state.searchText);
                        }
                    }}
                    remote={{
                        search: true,
                    }}
                    noDataIndication={
                        <div className="text-center text-muted">
                            Nenhum motivo de cancelamento
                        </div>
                    }
                />
            </div>
            <div className="col-12 mt-2">
                <Collapse in={!!editting} mountOnEnter unmountOnExit>
                    <CreateUpdateMotivoCancelamento
                        motivoCancelamento={editting}
                        onSave={() => {
                            updateList();
                            setEditting(undefined);
                        }}
                    />
                </Collapse>
            </div>
        </div>
    );
}
